import { render, staticRenderFns } from "./IndexPageSection.vue?vue&type=template&id=77ee44bd&"
import script from "./IndexPageSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports